'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _constants = require('../constants');

/**
 * Error reporter to deal with unexpected errors bubbling up
 */
var createReporter = function createReporter(Raven, notifications, _ref) {
  var logging = _ref.logging,
      raven = _ref.raven,
      timeout = _ref.timeout;

  var throttledCapture = (0, _lodash.throttle)(Raven.captureException, timeout || _constants.ERROR_REPORING_THROTTLE_TIMEOUT);
  return function (error, componentError) {
    if (logging) {
      // eslint-disable-next-line no-console
      console.error(error);
    }

    if (!componentError) {
      notifications.error("We're sorry! An error has occured. Don't worry, our team has been notified.");
    }

    if (raven) {
      throttledCapture(error, { extra: componentError });
    }
  };
};

exports.default = createReporter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/errorReporter.js
// module id = 1226
// module chunks = 0